import React, { useEffect, useState } from "react";
import {
  fetchBuOptions,
  getDeptUsers,
  getNamesofAgreement,
} from "../apis/userApis";
import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import {
  excelDownload,
  getComplianceBadgeColor,
  getDateStatus,
  getDepartmentText,
  getStatusColor,
  getStatusText,
  infoColor,
} from "./utilities";
import {
  IconEye,
  IconHistory,
  IconInfoCircle,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { getAllObligations, getTitlesApi } from "../apis/obligationApi";
import { departmentData } from "./utilities";
import { DatePicker } from "@mantine/dates";
import { getCookiesSession } from "../apis/cookiesSession";

const CompletedObligation = () => {
  const userData = JSON.parse(getCookiesSession("userData"));
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const navigate = useNavigate();
  let filterForUser = {
    compliant: null,
    department:
      userData.loginAs === "Ob-CXO" || userData.loginAs === "Ob-DeptAdmin"
        ? userData.activeDepartment
        : null,
    businessUnit: userData.loginAs === "Ob-COO" ? userData.businessUnit : null,
    extraCol1: null,
    assignToId: null,
    joOrder: null,
    duedate: null,
  };
  const [filters, setFilters] = useState(filterForUser);
  const [configs, setConfigs] = useState({
    loading: true,
    obligations: null,
    count: 0,
  });
  const [buData, setBuData] = useState(null);

  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);

  useEffect(() => {
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getNames();
  }, []);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    getBuData();
  }, []);
  const [applyfilters, setApplyFilters] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [partyName, setPartyName] = useState("");
  const [status, setStatus] = useState(null);
  const [assignToData, setAssignToData] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [csvData, setCsvData] = useState([]);
  let sr = (page - 1) * pageSize + 1;
  const [sortByOptions, setSortByOptions] = useState({
    key: "duedate",
    value: "asc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  useEffect(() => {
    const getObligation = async () => {
      const filterdata = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== null)
      );
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await getAllObligations({
        page: page,
        partyName: partyName,
        filters: filterdata,
        pageSize,
        status,
        sortByOptions: sortOption,
      });
      setConfigs({
        loading: false,
        obligations: response.obligations,
        count: response.count,
      });
      setCsvData(response.exportData)
      console.log("response: ", response);
    };
    getObligation();
    const getassignToUsers = async () => {
      const response = await getDeptUsers();
      setAssignToData(response.userData);
    };
    getassignToUsers();
    const getTitles = async () => {
      const response = await getTitlesApi();
      if (response.success) {
        setTitleOptions(response.titles);
      }
    };
    getTitles();
  }, [page, applyfilters, pageSize, sortByOptions]);
  const onExport = async () => {
      if (csvData.length > 0) {
        const columnHeaders = Object.keys(csvData[0]);
        excelDownload({
          data: csvData,
          headers: columnHeaders,
          name: "obligation_monitor",
        });
      }
    };
  const onViewClick = ({ id }) => {
    window.open(`/viewobligation/${id}`, '_blank');
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID

  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };

  return (
    <>
      <Text className="font-semibold text-xl m-4">obligations monitor</Text>

      <div className="grid grid-cols-6 gap-4 m-4">
        <Select
          placeholder="select compliance"
          label="compliance"
          value={filters.compliant}
          data={[
            { label: "upcoming", value: "upcoming" },
            {label: "due", value: "due"},
            { label: "non-compliant", value: "non-compliant" },
            {
              label: "partially-compliant",
              value: "partially-compliant",
            },
            { label: "compliant", value: "compliant" },
            {
              label: "delayed-compliant",
              value: "delayed-compliant",
            },
          ]}
          onChange={(val) => setFilters({ ...filters, compliant: val })}
        />
        <Select
          placeholder="select status"
          label="status"
          value={status}
          data={[
            { label: "upcoming", value: "upcoming" },
            {
              label: "due",
              value: "due",
            },
            { label: "overdue", value: "overdue" },
          ]}
          onChange={(val) => setStatus(val)}
        />
        {userData.loginAs !== "Ob-DeptAdmin" &&
        userData.loginAs !== "Ob-CXO" ? (
          <Select
            searchable
            label="department"
            placeholder="select department"
            data={departmentData}
            onChange={(val) => setFilters({ ...filters, department: val })}
            value={filters.department}
          />
        ) : (
          <Select
            searchable
            label="assigned to "
            data={assignToData}
            placeholder="assigned to"
            value={filters.assignToId}
            onChange={(val) => setFilters({ ...filters, assignToId: val })}
          />
        )}
        {buData !== null && userData.loginAs !== "Ob-COO" && (
          <Select
            searchable
            label="business unit"
            placeholder="select business unit"
            value={filters.businessUnit}
            data={buData}
            onChange={(val) => setFilters({ ...filters, businessUnit: val })}
          />
        )}
        <Select
          searchable
          label="agreement type"
          placeholder="agreement type"
          value={filters.extraCol1}
          data={categoryOptions}
          onChange={(val) => setFilters({ ...filters, extraCol1: val })}
        />
        <TextInput
          searchable
          label="second party name"
          placeholder="type party name"
          value={partyName}
          onChange={(e) => setPartyName(e.target.value)}
        />
        <TextInput
          label="job order"
          placeholder="job order"
          value={filters?.joOrder?.contains}
          onChange={(e) =>
            setFilters({
              ...filters,
              joOrder: { contains: e.target.value },
            })
          }
        />
        <Select
          searchable
          label="obligation title"
          placeholder="obligation title"
          data={titleOptions}
          value={filters.title}
          onChange={(val) => setFilters({ ...filters, title: val })}
        />
        <DatePicker
          label="due date start from"
          placeholder="start from"
          value={filters?.duedate?.gt}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, gte: val },
            })
          }
        />
        <DatePicker
          label="due date till"
          placeholder="range end date"
          value={filters.duedate?.lte}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, lte: val },
            })
          }
        />
      </div>
      <div className="m-4">
        <Button
          onClick={() => setApplyFilters(!applyfilters)}
          className="mr-4"
          color="green"
        >
          search
        </Button>
        <Button
          onClick={() => {
            window.location.reload();
            // setFilters(filterForUser);
            // setPartyName("");
            // setStatus(null);
            // setApplyFilters(!applyfilters);
          }}
          color="red"
        >
          clear
        </Button>
      </div>
      <div className="flex justify-end">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "start date", value: "startDate" },
              { label: "due date", value: "duedate" },
              { label: "second party", value: "connectedParty" },
              { label: "id", value: "id" },
              { label: "brand name", value: "brandName" },
              { label: "title", value: "title" },
            ]}
          />

          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <IconSortAscending size={32} />
            ) : (
              <IconSortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button onClick={onExport}>export</Button>
      </div>
      <div className="m-4">
        {!configs.loading && configs.obligations && (
          <>
            <Table striped>
              <thead className="text-center">
                <tr>
                  <th style={{ textAlign: "center" }}>id</th>
                  <th style={{ textAlign: "center" }}>title</th>
                  <th style={{ textAlign: "center" }}>description</th>
                  <th style={{ textAlign: "center" }}>job order</th>
                  <th style={{ textAlign: "center" }}>agreement type</th>
                  {/* <th style={{ textAlign: "center" }}>business unit</th> */}
                  <th style={{ textAlign: "center" }}>second party</th>
                  <th style={{ textAlign: "center" }}>department</th>
                  <th style={{ textAlign: "center" }}>assign to </th>
                  <th style={{ textAlign: "center" }}>status</th>
                  <th style={{ textAlign: "center" }}>compliance</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {configs.obligations.map((obligation) => (
                  <tr key={obligation.id}>
                    <td style={{ textAlign: "center" }}>{obligation.id}</td>
                    <td style={{ textAlign: "center" }}>{obligation.title}</td>
                    <td style={{ textAlign: "center" }}>
                      {expandedId === obligation.id
                        ? obligation.desc // Show full description if expanded
                        : obligation.desc.slice(0, 50)}
                      {/* Truncated description */}
                      {expandedId !== obligation.id &&
                        obligation.desc.length > 50 && (
                          <span
                            onClick={() => handleExpand(obligation.id)}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            ...
                          </span>
                        )}
                    </td>
                    <td>{obligation.joOrder}</td>
                    <td style={{ textAlign: "center" }}>
                      {obligation.extraCol1}
                    </td>
                    {/* <td style={{ textAlign: "center" }}>
                      {obligation.businessUnit}{" "}
                    </td> */}
                    <td style={{ textAlign: "center" }}>
                      <h3>{obligation.brandName}</h3>
                      {"(" + obligation.connectedParty + ")"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {getDepartmentText(obligation.department)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {obligation.assignTo.name}
                    </td>

                    <td>
                      <Badge
                        variant="light"
                        color={getStatusColor(
                          getDateStatus(
                            obligation.startDate,
                            obligation.duedate,
                            obligation.reminderTime
                          )
                        )}
                      >
                        {getStatusText(
                          getDateStatus(
                            obligation.startDate,
                            obligation.duedate,
                            obligation.reminderTime
                          )
                        )}
                      </Badge>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Badge
                        variant="light"
                        color={getComplianceBadgeColor(obligation.compliant)}
                      >
                        {obligation.compliant}
                      </Badge>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div className="flex flex-row mr-4">
                        <ActionIcon
                          onClick={() => {
                            onViewClick({ id: obligation.id });
                          }}
                          color="white"
                        >
                          <IconEye size={24} />
                        </ActionIcon>
                        {/* )} */}
                      </div>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div className="flex flex-row mr-4">
                        <ActionIcon
                          color="white"
                          onClick={() => {
                            setAhId(obligation.id);
                            setAhModal(true);
                          }}
                        >
                          <IconHistory size={24} />
                        </ActionIcon>
                      </div>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div className="flex flex-row mr-4">
                        {obligation.extraCol3 !== "" && (
                          <ActionIcon color="white">
                            <IconInfoCircle
                              color={infoColor(obligation.extraCol3)}
                              size={24}
                            />
                          </ActionIcon>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="flex flex-row justify-center my-4 gap-4">
              <Pagination
                page={page}
                onChange={(page) => {
                  setPage(page);
                }}
                total={Math.ceil(configs.count / pageSize)}
              />

              <Select
                style={{ width: "70px" }}
                value={pageSize + ""}
                data={["10", "20", "50"]}
                onChange={(val) => setPageSize(parseInt(val))}
              />
            </div>
          </>
        )}
        <Modal
          opened={ahModal}
          onClose={() => {
            setAhModal(false);
            setAhId(0);
          }}
          title="oblligation action history"
          size="calc(80vw)"
        >
          <ObligationTranHistoryModal id={ahId} />
        </Modal>
      </div>
    </>
  );
};

export default CompletedObligation;
